/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../static/scss/resources/default.variables.scss';
@import '../../../static/scss/resources/default.style.scss';

.preferences_tree{
  padding: 0px;
  padding-top: 2px;
  height: 100%;
  overflow: auto;
  border-right: $panel-border;
}

.btn-checkbox {
  padding: $btn-checkbox-padding;

  & input[type="checkbox"]{
    margin-top: 0px !important;
  }
}
